import { Stack, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { useEffect } from 'react';

import { StatusProgressDots } from '@/components/DataDisplay/Indicator/StatusProgressDots';
import { Screen } from '@/components/Layout/Screen';
import { MoreInformationContainer } from '@/components/MoreInformation/MoreInformationContainer';
import { Avatar } from '@/components/User/Avatar';

import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectRightStartFeature } from '@/redux/configs/selectors';
import { showReviewPersonalInfo, showUserInfo } from '@/redux/ui/actions';
import {
  selectBasicInfoStatus,
  selectSigningDocuments,
  selectUserData,
} from '@/redux/user-data/selectors';

import { isExistingCustomer } from '@/utils/user';

export default function MoreInformationScreen() {
  const dispatch = useAppDispatch();
  const { t } = useTranslate();
  const theme = useTheme();
  const { user, requiredDocumentSections } = useAppSelector(selectUserData);
  const enabledRightStart = useAppSelector(selectRightStartFeature);
  const basicInfoStatus = useAppSelector(selectBasicInfoStatus);
  const { documentsSigningStatus } = useAppSelector(selectSigningDocuments);

  useEffect(() => {
    if (user) {
      if (isExistingCustomer(user) && !user.clientReviewed) {
        dispatch(showReviewPersonalInfo());
      }
    }
  }, [dispatch, user]);

  const statusDots = [
    basicInfoStatus,
    ...requiredDocumentSections.map(({ status }) => status),
    documentsSigningStatus,
  ];

  const onShowUserInfo = () => {
    dispatch(showUserInfo());
  };

  return (
    <Screen
      header={{
        bgColor: (theme: Theme) => theme.palette.neutral[100],
        centerSlot: <StatusProgressDots dots={statusDots} />,
        rightSlot: (
          <Stack>
            <Avatar onClick={onShowUserInfo}>{user?.firstName}</Avatar>
          </Stack>
        ),
        leftSlot: <div />,
      }}
    >
      <Typography variant="h3" textAlign="center" mt={4} mb={1}>
        {t('moreInfo.title')}
      </Typography>
      <Typography
        variant="body2"
        textAlign="center"
        color={theme.palette.neutral[800]}
        mb={4}
      >
        {enabledRightStart ? t('moreInfo.body.rightStart') : t('moreInfo.body')}
      </Typography>
      <MoreInformationContainer />
    </Screen>
  );
}
